import './VideoItem.css'

const VideoItem = ({video, onVideoSelect}) =>{
    console.log(video)
    return (
        <div onClick={()=> onVideoSelect(video)} className=" video-item item">
            <img  alt="video.snippet.title" className="ui avatar" src={video.snippet.thumbnails.high.url} />
            <div className="header" style={{marginLeft:'6px'}}>
               {video.snippet.title}
            </div>
        </div>
    );
}
export default VideoItem